import React from "react";
import { Spacer } from "../../spacer";
import styles from "./portal_empty_state.module.css";

interface PortalEmptyStateProps {
  title: string;
  description: string;
  link?: {
    href: string;
    text: string;
  };
}

export function PortalEmptyState({
  title,
  description,
  link,
}: PortalEmptyStateProps) {
  return (
    <div className={styles.component}>
      <div className={styles.title}>{title}</div>
      <Spacer size={16} />
      <div>
        {description}
        {link && (
          <a
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.link}
          >
            {" "}
            {link.text}
          </a>
        )}
      </div>
    </div>
  );
}
